import { render, staticRenderFns } from "./Interaction.vue?vue&type=template&id=565f9e96&scoped=true"
import script from "./Interaction.vue?vue&type=script&lang=js"
export * from "./Interaction.vue?vue&type=script&lang=js"
import style0 from "./Interaction.vue?vue&type=style&index=0&id=565f9e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f9e96",
  null
  
)

export default component.exports